import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet-async'
import LanguageSwitcher from '../components/LanguageSwitcher'
import DarkModeToggle from '../components/DarkModeToggle'
import SEO from '../components/SEO'

function FAQ() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  // FAQ data for Schema.org structured data
  const faqItems = [
    {
      question: t('faq.q1'),
      answer: t('faq.a1'),
    },
    {
      question: t('faq.q2'),
      answer: t('faq.a2'),
    },
    {
      question: t('faq.q3'),
      answer: t('faq.a3'),
    },
    {
      question: t('faq.q4'),
      answer: t('faq.a4'),
    },
    {
      question: t('faq.q5'),
      answer: t('faq.a5'),
    },
    {
      question: t('faq.q6'),
      answer: t('faq.a6'),
    },
    {
      question: t('faq.q7'),
      answer: t('faq.a7'),
    },
    {
      question: t('faq.q8'),
      answer: t('faq.a8'),
    },
    {
      question: t('faq.q9'),
      answer: t('faq.a9'),
    },
    {
      question: t('faq.q10'),
      answer: t('faq.a10'),
    },
  ]

  // Generate Schema.org FAQPage structured data
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  }

  return (
    <>
      <SEO page="faq" />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>
      <div className="min-h-screen flex flex-col">
        {/* Controls - Top Right */}
        <div className="fixed top-4 right-4 z-50 flex items-center gap-2">
          <DarkModeToggle />
          <LanguageSwitcher />
        </div>

        {/* Main Content */}
        <div className="flex-1 flex items-start justify-center p-4 pt-20">
          <div className="w-full max-w-4xl">
            <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-8 md:p-12 transition-colors">
              {/* Back Button */}
              <button
                onClick={() => navigate('/')}
                className="mb-6 text-indigo-600 dark:text-indigo-400 hover:text-indigo-700 dark:hover:text-indigo-300 font-semibold flex items-center gap-2"
              >
                ← {t('common.back')}
              </button>

              {/* Header */}
              <div className="mb-8">
                <h1 className="text-4xl font-bold mb-4 dark:text-white">
                  {t('faq.title')}
                </h1>
                <p className="text-gray-600 dark:text-gray-400 text-lg">
                  {t('faq.subtitle')}
                </p>
              </div>

              {/* FAQ Items */}
              <div className="space-y-6">
                {faqItems.map((item, index) => (
                  <div
                    key={index}
                    className="border-b border-gray-200 dark:border-gray-700 pb-6 last:border-0"
                  >
                    <h2 className="text-xl font-semibold mb-3 dark:text-white">
                      {item.question}
                    </h2>
                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed whitespace-pre-line">
                      {item.answer}
                    </p>
                  </div>
                ))}
              </div>

              {/* Additional Help Section */}
              <div className="mt-12 p-6 bg-indigo-50 dark:bg-indigo-900/20 rounded-lg">
                <h3 className="text-lg font-semibold mb-2 dark:text-white">
                  {t('faq.moreHelp')}
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  {t('faq.moreHelpText')}
                </p>
                <button
                  onClick={() => navigate('/spielanleitung')}
                  className="text-indigo-600 dark:text-indigo-400 hover:text-indigo-700 dark:hover:text-indigo-300 font-semibold"
                >
                  {t('faq.viewGuide')} →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default FAQ
